import { PAGE_KEY } from './constants';

export const pt = {
  [PAGE_KEY]: {
    TITLE: 'Cobertura de sucessão',
    DESCRIPTION:
      'Monitore quais cargos têm sucessores identificados e detecte riscos na continuidade do talento para garantir a estabilidade e sustentabilidade da liderança na organização',
    PERFORMANCE: 'Desempenho',
    SUCCESSION_COVERAGE: 'Cobertura de sucessão',
    TABLE_TITLE: 'Cargos',
    SEARCH_PLACEHOLDER: 'Buscar cargos',
    CRITICALITY_HIGH: 'Alta',
    CRITICALITY_MEDIUM: 'Média',
    CRITICALITY_LOW: 'Baixa',
    SUCCESSOR_COVERED: 'Coberta',
    SUCCESSOR_NO_SUCCESSOR: 'Sem sucessor',
    AI_SUGGESTIONS_TOOLTIP:
      'Candidatos identificados por IA: Este cargo tem sugestões geradas de acordo com o perfil do cargo e os critérios definidos.',
    HIGH_RISK_TOOLTIP:
      'Risco alto: Este cargo é de alta criticidade e atualmente não possui sucessor confirmado nem candidatos identificados. Recomenda-se priorizar sua cobertura.',
    COLUMN_POSITION: 'Cargo',
    COLUMN_CRITICALITY: 'Criticidade',
    COLUMN_SUGGESTED_CANDIDATES: 'Candidatos sugeridos',
    COLUMN_CONFIRMED_SUCCESSOR: 'Sucessor confirmado',
    TOOLTIP_VIEW_POSITION_DETAIL: 'Ver detalhes do cargo',
    ALERT_SELECTED_RECORD: 'Registro selecionado: {{id}}',
    ERROR_TITLE: 'Ocorreu um erro no carregamento',
    ERROR_DESCRIPTION: 'Clique no botão para tentar carregar novamente.',
    ERROR_RETRY_BUTTON: 'Tentar novamente',
    TOTAL_COVERAGE_TITLE: 'Cobertura total de sucessão',
    COVERED_POSITIONS: 'cargos cobertos',
    PRIORITY_HIGH: 'Alta',
    PRIORITY_MEDIUM: 'Média',
    PRIORITY_LOW: 'Baixa',
    POSITIONS_WITHOUT_COVERAGE: 'Cargos sem cobertura',
    POSITIONS_COUNT: 'cargos',
    VIEW_POSITIONS_AT_RISK: 'Ver cargos em risco',
    LAST_UPDATE: 'Última atualização em',
    POSITIONS_WITH_CONFIRMED_SUCCESSOR: 'Cargos com sucessor confirmado',
    VIEW_COVERED_POSITIONS: 'Ver cargos cobertos',
    OF: 'de',
    EMPTY_TABLE_TITLE: 'Nenhum cargo disponível',
    EMPTY_TABLE_SUBTITLE: 'Nenhum cargo encontrado correspondente à sua busca.',
  },
};
